import { Tabs as TabsPrimitive } from "@base-ui/react/tabs";

import { cn } from "@/lib/utils";

const Tabs = TabsPrimitive.Root;

function TabsList({ className, ...props }: TabsPrimitive.List.Props) {
    return (
        <TabsPrimitive.List
            data-slot="tabs-list"
            className={cn(
                "relative flex items-center border-zinc-200 border-b dark:border-zinc-800",
                className,
            )}
            {...props}
        />
    );
}

function TabsTrigger({ className, ...props }: TabsPrimitive.Tab.Props) {
    return (
        <TabsPrimitive.Tab
            data-slot="tabs-trigger"
            className={cn(
                "relative cursor-pointer select-none px-3 py-2.5 font-medium text-sm outline-none transition-colors",
                "text-zinc-500 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-300",
                "data-active:border-zinc-900 data-active:border-b-2 data-active:text-zinc-900 dark:data-active:border-zinc-100 dark:data-active:text-zinc-100",
                className,
            )}
            {...props}
        />
    );
}

function TabsIndicator({ className, ...props }: TabsPrimitive.Indicator.Props) {
    return (
        <TabsPrimitive.Indicator
            data-slot="tabs-indicator"
            className={cn(
                "absolute bottom-0 h-0.5 rounded-t bg-zinc-900 transition-[left,right,width] duration-150 dark:bg-zinc-100",
                className,
            )}
            {...props}
        />
    );
}

function TabsContent({ className, ...props }: TabsPrimitive.Panel.Props) {
    return (
        <TabsPrimitive.Panel
            data-slot="tabs-content"
            className={cn("outline-none", className)}
            {...props}
        />
    );
}

export { Tabs, TabsContent, TabsIndicator, TabsList, TabsTrigger };
